import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams, Navigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import AuthService from '../../../services/AuthService/authService.service';
import { ResetScreen } from './constants';
import ResetPasswordScreen from './index';
import { useAuth } from '../../../context/AuthContext';
import { AppRoutes } from '../../../routes/routeConstants/appRoutes';

const VerifyResetToken: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { authenticated: isAuthenticated } = useAuth();
  const { verifyResetLink } = AuthService();

  const { isLoading, isError, error, data } = useQuery(verifyResetLink(id, isAuthenticated));

  const isExpired = (error as AxiosError)?.response?.status === 400;

  const screen = useMemo<ResetScreen>(() => {
    if (!id) return ResetScreen.FAILED;
    if (isLoading) return ResetScreen.VERIFYING;
    if (isError) return isExpired ? ResetScreen.EXPIRED : ResetScreen.FAILED;
    return ResetScreen.FORM;
  }, [id, isLoading, isError, isExpired]);

  if (isAuthenticated) return <Navigate to={AppRoutes.HOME} replace />;

  return <ResetPasswordScreen screen={screen} userName={data?.user?.name} />;
};

export default VerifyResetToken;
